// Feedback háptico cross-platform (10/06).
// Android (Chrome/PWA): Vibration API direto.
// iPhone: Safari NÃO suporta navigator.vibrate — usa o hack do <input type="checkbox" switch>
// (iOS 17.4+), que dispara o haptic nativo do toggle. Só funciona dentro de gesto real do
// usuário (clique síncrono); após await o iOS ignora — Android continua vibrando.
// iOS < 17.4: falha silenciosa (sem erro, sem vibração). Nunca lança.

const isIOS = /iPhone|iPad|iPod/.test(navigator.userAgent)
  || (navigator.userAgent.includes('Mac') && 'ontouchend' in document);

function iosTap() {
  try {
    const label = document.createElement('label');
    label.ariaHidden = 'true';
    label.style.display = 'none';
    const input = document.createElement('input');
    input.type = 'checkbox';
    input.setAttribute('switch', '');
    label.appendChild(input);
    document.head.appendChild(label);
    label.click();
    document.head.removeChild(label);
  } catch { /* best-effort */ }
}

function vibrate(pattern: number | number[]) {
  try {
    if (isIOS) iosTap();
    else navigator.vibrate?.(pattern);
  } catch { /* best-effort */ }
}

/** Tap curto no clique de botão principal (salvar, emitir, check-in). */
export const haptic = () => vibrate(40);

/** Tick sutil de navegação (bottom nav, sidebar, voltar) — mais leve que o tap de ação. */
export const hapticNav = () => vibrate(10);

/** Vibração dupla de sucesso (pedido emitido, rascunho salvo). */
export const hapticConfirm = () => {
  if (isIOS) { iosTap(); setTimeout(iosTap, 120); }
  else vibrate([40, 60, 40]);
};

/** Vibração tripla de erro (falha ao salvar). */
export const hapticError = () => {
  if (isIOS) { iosTap(); setTimeout(iosTap, 100); setTimeout(iosTap, 200); }
  else vibrate([60, 50, 60, 50, 60]);
};
